/**
 * @description Labels for transactions.payment_method vs invoice_payments rail.
 * @dependencies None (pure).
 * @notes transactions.chk_payment_method stores external for both
 * "Credit Card (already collected)" and "Other". The invoice_payments rail
 * (credit_card | other) is the display SoT so those two stay distinguishable.
 */

/**
 * @param {unknown} method
 * @returns {string}
 */
function normalizeMethodKey(method) {
  return String(method ?? '').trim().toLowerCase();
}

/**
 * Human label for a payment method.
 * @param {unknown} transactionMethod - Canonical transactions.payment_method
 * @param {unknown} [invoicePaymentMethod] - invoice_payments.payment_method rail
 * @returns {string}
 */
export function formatPaymentMethodLabel(transactionMethod, invoicePaymentMethod) {
  const key = normalizeMethodKey(invoicePaymentMethod || transactionMethod);

  if (key === 'credit_card' || key === 'debit_card') {
    return 'Credit Card (already collected)';
  }
  if (key === 'card') {
    return 'Credit Card';
  }
  if (key === 'bank_transfer' || key === 'wire' || key === 'bank') {
    return 'Bank Transfer';
  }
  if (key === 'cash') {
    return 'Cash';
  }
  if (key === 'check') {
    return 'Check';
  }
  if (key === 'external' || key === 'other') {
    return 'Other';
  }
  if (key === 'linked') {
    return 'Linked Transaction';
  }
  if (key === 'ach') {
    return 'Bank Transfer';
  }
  return key ? String(invoicePaymentMethod || transactionMethod) : 'Not Specified';
}

/**
 * Value for the offline-method <select> so credit_card stays selected after persist.
 * @param {{ paymentMethod?: string, invoicePaymentMethod?: string }} transaction
 * @returns {string}
 */
export function resolveEditablePaymentMethod(transaction = {}) {
  const invoiceRail = normalizeMethodKey(transaction.invoicePaymentMethod);
  if (invoiceRail) {
    return invoiceRail;
  }
  return normalizeMethodKey(transaction.paymentMethod);
}
